<template>
  <div class="select-outer-container" :class="`${selectClass}`">
    <div
      class="form-group row"
      :class="`${styleClass.parentElement} ${wrapClass} ${
        $slots.note ? 'mb-0' : ''
      }`"
    >
      <label
        class="col-2 col-form-label"
        :class="`${styleClass.label} ${labelClass}`"
        :for="inputId"
      >
        <slot></slot>
      </label>
      <div class="col">
        <select
          :id="inputId"
          :class="`form-control ${inputClass}`"
          :value="modelValue === null ? '' : modelValue"
          @input="update($event.target.value)"
          :required="required"
          :disabled="disabled"
        >
          <option value="" v-if="!options || options.length === 0">
            Select an option
          </option>
          <option
            :class="i.class"
            v-for="i in options"
            :key="i.value"
            :value="i.value === null ? '' : i.value"
          >
            {{ i.label }}
          </option>
        </select>
      </div>
    </div>
    <small v-if="$slots.note" class="form-text text-muted d-block mt-2">
      <slot name="note"></slot>
    </small>
  </div>
</template>
<script>
export default {
  name: "SelectControl",
  props: {
    type: {
      type: String,
    },
    labelClass: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "",
    },
    wrapClass: {
      type: String,
      default: "",
    },
    selectClass: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [String, Boolean, Number],
      default: "",
    },
  },

  emits: ["update:modelValue", "input"],

  computed: {
    inputId: function () {
      let id = this.$slots.default
        ? this.$slots
            .default()[0]
            .children.toLowerCase()
            .replace(/[^a-z0-9]+/gi, "-")
        : Math.random();
      return `select-control-${id}`;
    },
  },
  data() {
    return {
      styleClass: {
        parentElement: "",
        label: "",
        input: "",
      },
    };
  },
  mounted() {
    if (this.type == "horizontal") {
      this.styleClass.label = "";
      this.styleClass.input = "col";
    } else if (this.type == "vertical") {
      this.styleClass.parentElement = "flex-column";
      this.styleClass.label = "col-12";
      this.styleClass.input = "";
    }
  },

  methods: {
    update: function (value) {
      // Convert empty string back to null for consistency
      const actualValue = value === "" ? null : value;
      const option = this.options.find((opt) => opt.value == actualValue);
      const convertedValue = option ? option.value : actualValue;

      this.$emit("update:modelValue", convertedValue);
      this.$emit("input", convertedValue);
    },
  },
};
</script>
